/**
 * Detects if the device is a touch device with native smooth scrolling (iOS, modern Android)
 */
export const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') return false;

  // Check for touch support
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check for mobile/tablet user agents (iOS, Android)
  const isMobileOS = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return hasTouch && isMobileOS;
};
